export default __webpack_public_path__ + "static/jvictoriacollege-ca-logo-59c13ed2d9c09c9776c6c6b471802b42.png";